export default "__VITE_ASSET__DacFc7fo__"